module.exports = angular.module('add-date-time-ctrl', [])
    .controller('addDateTimeFormCtrl',['$rootScope', '$scope', 'canvasService', 'timezoneFactory', '$timeout', function ($rootScope, $scope, canvasService, timezoneFactory, $timeout) {
        $scope.timeZones = timezoneFactory.get();
        $scope.displayAddListActionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.$parent.createListName = {};
        $scope.search = {};

        if ($scope.connections.length !== undefined) {
            let now = new Date();

            //Start new Connection obj
            $scope.connections = {
                id:'entry_' + now.getTime(),
                data: {
                    time: '',
                    timezoneName: '',
                    selectedList: []
                }
            };
        }

        $scope.$parent.connections = $scope.connections;

        var sunDay = $scope.translate('timePicker.sun'),
            mon = $scope.translate('timePicker.mon'),
            tue = $scope.translate('timePicker.tue'),
            wed = $scope.translate('timePicker.wed'),
            thu = $scope.translate('timePicker.thrus'),
            fri = $scope.translate('timePicker.fri'),
            sat = $scope.translate('timePicker.sat'),
            jan = $scope.translate('timePicker.jan'),
            feb = $scope.translate('timePicker.feb'),
            mar = $scope.translate('timePicker.mar'),
            apr = $scope.translate('timePicker.apr'),
            may = $scope.translate('timePicker.may'),
            jun = $scope.translate('timePicker.jun'),
            jul = $scope.translate('timePicker.jul'),
            aug = $scope.translate('timePicker.aug'),
            set = $scope.translate('timePicker.set'),
            oct = $scope.translate('timePicker.oct'),
            nov = $scope.translate('timePicker.nov'),
            dec = $scope.translate('timePicker.dec');

        $('#date-picker').datetimepicker({
            stepMinute: 15,
            minDate: 0,
            dayNamesMin: [sunDay, mon, tue, wed, thu, fri, sat],
            monthNames: [jan, feb, mar, apr, may, jun, jul, aug, set, oct, nov, dec],
            currentText: $scope.translate('timePicker.now'),
            closeText: $scope.translate('timePicker.done'),
            amNames: ['AM', 'A'],
            pmNames: ['PM', 'P'],
            timeFormat: 'HH:mm',
            timeSuffix: '',
            timeOnlyTitle: $scope.translate('timePicker.choooseTime'),
            timeText: $scope.translate('timePicker.time'),
            hourText: $scope.translate('timePicker.hour'),
            minuteText: $scope.translate('timePicker.minute'),
            secondText: $scope.translate('timePicker.second'),
            millisecText: $scope.translate('timePicker.millisecond'),
            microsecText: $scope.translate('timePicker.microsecond'),
            timezoneText: $scope.translate('timePicker.timeZone'),
        });

        $('#date-picker').on('change', function () {
            $scope.$emit('updateDateFormCtrl', $(this).val());
        });

        $scope.triggerDatePicker = () => {
            $timeout(function(){
                document.getElementById('date-picker').focus();
            });
        };

        $scope.sortDataList = () => {
            $scope.contactListData = $scope.contactListData.map((i) => {
                if($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
        };
        $scope.sortDataList();

        $scope.toggelListItem = function (listItem, $i) {
            if($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.contactListData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.contactListData[$i].selectedItem = true;
            }

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.triggerDatePicker = () => {
            $timeout(function(){
                document.getElementById('date-picker').focus();
            });
        };

        $scope.setScrollLogic = function(id) {
            $scope.listLoader = false;
            angular.element(
                document.getElementById('contactListContainer' + id)).bind("scroll",
                function () {
                    if(!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                        $scope.listLoader = true;
                        canvasService.getContactList($rootScope.contactListOffset, 10)
                            .success(function(data) {
                                if(!data.Results.length) {
                                    $rootScope.stopLoadingList = true;
                                }
                                else {
                                    $rootScope.contactListOffset++;
                                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                                    $scope.contactListData = $rootScope.contactListData;
                                    Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
                                }
                                $scope.listLoader = false;
                            })
                            .error(function() {
                                $scope.listLoader = false;
                            })
                    }
                }
            );
        };

        $scope.searching = false;
        $scope.search.search = (val) => {
            if(val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                        $scope.contactListData = [];
                        $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                        $scope.sortDataList();
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.contactListData = $rootScope.contactListData;
                $scope.sortDataList();
            }
        };

        setTimeout(function() {
            $scope.setScrollLogic($scope.connections.id);
        }, 100);

        // Functionality for add a new list name
        $scope.showCreateListNameModal = () => {
            $scope.$parent.showTriggerPanelModal = false;
            $scope.$parent.showCreateListName = true;
        };

        $scope.$parent.goCreateList = () => {
            if ($scope.$parent.createListName.name === undefined) {
                $scope.$parent.showNewListNameError = true
            }

            if($scope.$parent.createListName.name) {
                $scope.$parent.createListLoader = true;

                canvasService.createContactList($scope.$parent.createListName.name).success(({Results}) => {
                    if(Results.length) {
                        const result = Results[0];
                        const listItem = {
                            ContactCount: 0,
                            ListId: result.ListId,
                            ListName: result.ListName
                        };
                        $scope.contactListData.unshift(listItem);
                        $rootScope.contactListData.unshift(listItem);
                        $scope.toggelListItem(result.ListId, 0);
                        $scope.createList = false;
                        $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                        $scope.$parent.hideAddNewList();
                    }
                    else {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    }
                }).error(() => {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                }).finally(function () {
                    $scope.$parent.createListLoader = false;
                });
            }
        };

        $scope.$parent.hideAddNewList = () => {
            $scope.$parent.showTriggerPanelModal = true;
            $scope.isAddToListFormDisplayed = true;
            $scope.$parent.showCreateListName = false;
        };
        // End Functionality for add a new list name

        $scope.$watch('connections.data.timezoneName', function(val) {
            if(val) {
                let valuesArray = ["Morocco Standard Time, Text=Casablanca", "GMT Standard Time, Text=(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London ", "Greenwich Standard Time, Text=(GMT) Monrovia, Reykjavik ", "W. Europe Standard Time, Text=(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna ", "Central Europe Standard Time, Text=(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague ", "Romance Standard Time, Text=(GMT+01:00) Brussels, Copenhagen, Madrid, Paris ", "Central European Standard Time, Text=(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb ", "W. Central Africa Standard Time, Text=(GMT+01:00) West Central Africa ", "Jordan Standard Time, Text=(GMT+02:00) Amman ", "GTB Standard Time, Text=(GMT+02:00) Athens, Bucharest, Istanbul ", "Middle East Standard Time, Text=(GMT+02:00) Beirut ", "Egypt Standard Time, Text=(GMT+02:00) Cairo ", "South Africa Standard Time, Text=(GMT+02:00) Harare, Pretoria ", "FLE Standard Time, Text=(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius ", "Israel Standard Time, Text=(GMT+02:00) Jerusalem ", "E. Europe Standard Time, Text=(GMT+02:00) Minsk ", "Namibia Standard Time, Text=(GMT+02:00) Windhoek ", "Arabic Standard Time, Text=(GMT+03:00) Baghdad ", "Arab Standard Time, Text=(GMT+03:00) Kuwait, Riyadh ", "Russian Standard Time, Text=(GMT+03:00) Moscow, St. Petersburg, Volgograd ", "E. Africa Standard Time, Text=(GMT+03:00) Nairobi ", "Georgian Standard Time, Text=(GMT+03:00) Tbilisi ", "Iran Standard Time, Text=(GMT+03:30) Tehran ", "Arabian Standard Time, Text=(GMT+04:00) Abu Dhabi, Muscat ", "Azerbaijan Standard Time, Text=(GMT+04:00) Baku ", "Mauritius Standard Time, Text=(GMT+04:00) Port Louis ", "Caucasus Standard Time, Text=(GMT+04:00) Yerevan ", "Afghanistan Standard Time, Text=(GMT+04:30) Kabul ", "Ekaterinburg Standard Time, Text=(GMT+05:00) Ekaterinburg ", "Pakistan Standard Time, Text=(GMT+05:00) Islamabad, Karachi ", "West Asia Standard Time, Text=(GMT+05:00) Tashkent ", "India Standard Time, Text=(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi ", "Sri Lanka Standard Time, Text=(GMT+05:30) Sri Jayawardenepura ", "Nepal Standard Time, Text=(GMT+05:45) Kathmandu ", "N. Central Asia Standard Time, Text=(GMT+06:00) Almaty, Novosibirsk ", "Central Asia Standard Time, Text=(GMT+06:00) Astana, Dhaka ", "Myanmar Standard Time, Text=(GMT+06:30) Yangon (Rangoon) ", "SE Asia Standard Time, Text=(GMT+07:00) Bangkok, Hanoi, Jakarta ", "North Asia Standard Time, Text=(GMT+07:00) Krasnoyarsk ", "China Standard Time, Text=(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi ", "North Asia East Standard Time, Text=(GMT+08:00) Irkutsk, Ulaan Bataar ", "Singapore Standard Time, Text=(GMT+08:00) Kuala Lumpur, Singapore ", "W. Australia Standard Time, Text=(GMT+08:00) Perth ", "Taipei Standard Time, Text=(GMT+08:00) Taipei ", "Tokyo Standard Time, Text=(GMT+09:00) Osaka, Sapporo, Tokyo ", "Korea Standard Time, Text=(GMT+09:00) Seoul ", "Yakutsk Standard Time, Text=(GMT+09:00) Yakutsk ", "Cen. Australia Standard Time, Text=(GMT+09:30) Adelaide ", "AUS Central Standard Time, Text=(GMT+09:30) Darwin ", "E. Australia Standard Time, Text=(GMT+10:00) Brisbane ", "AUS Eastern Standard Time, Text=(GMT+10:00) Canberra, Melbourne, Sydney ", "West Pacific Standard Time, Text=(GMT+10:00) Guam, Port Moresby ", "Tasmania Standard Time, Text=(GMT+10:00) Hobart ", "Vladivostok Standard Time, Text=(GMT+10:00) Vladivostok ", "Central Pacific Standard Time, Text=(GMT+11:00) Magadan, Solomon Is., New Caledonia ", "New Zealand Standard Time, Text=(GMT+12:00) Auckland, Wellington ", "Fiji Standard Time, Text=(GMT+12:00) Fiji, Kamchatka, Marshall Is. ", "Tonga Standard Time, Text=(GMT+13:00) Nuku'alofa ", "Azores Standard Time, Text=(GMT-01:00) Azores ", "Cape Verde Standard Time, Text=(GMT-01:00) Cape Verde Is. ", "Mid-Atlantic Standard Time, Text=(GMT-02:00) Mid-Atlantic ", "E. South America Standard Time, Text=(GMT-03:00) Brasilia ", "Argentina Standard Time, Text=(GMT-03:00) Buenos Aires ", "SA Eastern Standard Time, Text=(GMT-03:00) Georgetown ", "Greenland Standard Time, Text=(GMT-03:00) Greenland ", "Montevideo Standard Time, Text=(GMT-03:00) Montevideo ", "Newfoundland Standard Time, Text=(GMT-03:30) Newfoundland ", "Atlantic Standard Time, Text=(GMT-04:00) Atlantic Time (Canada) ", "SA Western Standard Time, Text=(GMT-04:00) La Paz ", "Central Brazilian Standard Time, Text=(GMT-04:00) Manaus ", "Pacific SA Standard Time, Text=(GMT-04:00) Santiago ", "Venezuela Standard Time, Text=(GMT-04:30) Caracas ", "SA Pacific Standard Time, Text=(GMT-05:00) Bogota, Lima, Quito, Rio Branco ", "Eastern Standard Time, Text=(GMT-05:00) Eastern Time (US & Canada) ", "US Eastern Standard Time, Text=(GMT-05:00) Indiana (East) ", "Central America Standard Time, Text=(GMT-06:00) Central America ", "Central Standard Time, Text=(GMT-06:00) Central Time (US & Canada) ", "Central Standard Time (Mexico), Text=(GMT-06:00) Guadalajara, Mexico City, Monterrey ", "Canada Central Standard Time, Text=(GMT-06:00) Saskatchewan ", "US Mountain Standard Time, Text=(GMT-07:00) Arizona ", "Mountain Standard Time (Mexico), Text=(GMT-07:00) Chihuahua, La Paz, Mazatlan ", "Mountain Standard Time, Text=(GMT-07:00) Mountain Time (US & Canada) ", "Pacific Standard Time, Text=(GMT-08:00) Pacific Time (US & Canada) ", "Pacific Standard Time (Mexico), Text=(GMT-08:00) Tijuana, Baja California ", "Alaskan Standard Time, Text=(GMT-09:00) Alaska ", "Hawaiian Standard Time, Text=(GMT-10:00) Hawaii ", "Samoa Standard Time, Text=(GMT-11:00) Midway Island, Samoa ", "Dateline Standard Time, Text=(GMT-12:00) International Date Line West"],
                    onlyName = val.split(' (GMT'),
                    rawItem=  _.filter(valuesArray, function(item) {
                        return item.indexOf(onlyName[0]) > -1
                    }) || [];

                if(rawItem.length > 0) {
                    rawItem = rawItem[0].split(', Text=(');
                    $scope.connections.data.timezone = rawItem[0];
                }
            }
        });
    }]);



// WEBPACK FOOTER //
// ./app/controllers/triggerPanel/addDateTimeFormCtrl.js